import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {
  Chart,
  Title,
  Tooltip,
  Legend,
  DoughnutController,
  LineController,
  BarController,
  ArcElement,
  LineElement,
  BarElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler,
} from 'chart.js';

Chart.register(
  Title,
  Tooltip,
  Legend,
  DoughnutController,
  LineController,
  BarController,
  ArcElement,
  LineElement,
  BarElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler
);

store.dispatch('auth/loadSession');

import Swal from 'sweetalert2'

Vue.prototype.$swal = Swal;

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "@/assets/css/global.css";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.component("v-select", vSelect);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
